function processFormattedAmount(formattedAmount: string, options: { currency: string }) {
  const { currency } = options;
  let [symbol, amount, notation] = formattedAmount.split(/([\d,.]+)/);

  if (currency === 'INR') {
    if (notation && notation.includes('T')) {
      notation = notation.replace('T', 'K'); // changes '₹300T' to '₹300k', '₹300TCr' to '₹300KCr'
    }
  }

  return `${symbol}${amount} ${notation}`.trim();
}

export function formatCurrency(
  amount: number,
  options: { currency: string; locale?: string },
  formatOptions?: Intl.NumberFormatOptions
) {
  const { currency, locale } = options;
  const defaultLocale = currency === 'INR' ? 'en-IN' : 'en-US';

  const formattedAmount = new Intl.NumberFormat(locale ?? defaultLocale, {
    style: 'currency',
    currency: currency ?? 'USD',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    ...formatOptions,
  }).format(amount);

  return processFormattedAmount(formattedAmount, options);
}
